import { render, staticRenderFns } from "./UpdateStatisticDialog.vue?vue&type=template&id=6d2803fa&scoped=true&"
import script from "./UpdateStatisticDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateStatisticDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateStatisticDialog.vue?vue&type=style&index=0&id=6d2803fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2803fa",
  null
  
)

export default component.exports